import { useContext } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import * as yup from 'yup';
import { Link, useLocation } from 'react-router-dom';
import { shipmentTypeSchema } from '../ShipmentTypeDetailsContext';
import { applicationContext } from 'helpers/services';

let ShipmentTypeForm = () => {
    let router = useLocation();

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'New Shipment Type' : `Edit Shipment Type`;

    type ShipmentType = yup.InferType<typeof shipmentTypeSchema>;
    let form = useFormikContext<ShipmentType>();

    let appService = useContext(applicationContext);

    return (
        <Form>
            <Grid container spacing={2} alignItems='center'>
                <Grid item xs>
                    <Typography variant="h4">{title}</Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="medium"
                        component={Link}
                        to={'/admin/shipmenttypes'}
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        color="primary"
                    >
                        Save
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="code"
                        label="Code"
                        disabled={isNew === false}
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="description"
                        label="Description"
                        fullWidth
                        margin="dense"
                        size='small'
                    />
                </Grid>
            </Grid>
        </Form>
    );
}

export default ShipmentTypeForm;